var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKalender = function SvgKalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "#333",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 7.4,
    x: 1.5,
    y: 5,
    fill: "#FFF",
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 4,
    fill: "#333",
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 4.8,
    x: -0.4,
    y: -0.4,
    stroke: "#FFF",
    strokeWidth: 0.8,
    rx: 1.15
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 4,
    x: 8,
    fill: "#333",
    rx: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 4.8,
    x: 7.6,
    y: -0.4,
    stroke: "#FFF",
    strokeWidth: 0.8,
    rx: 1.15
  })))));
};
export default SvgKalender;